<template>
	<div class="newsItem" @click.stop="jumpBlog(item['link'])">
		<div class="eyecatchImage" :style="{'background-image':'url(' + item['image'] + ')'}"></div>
		<div class="info_area">
			<div class="tbl" style="width:100%">
				<div class="tblrow">
					<div class="tblcell"><div class="title">{{ item['title'] }}</div></div>
				</div>
				<div class="tblrow">
					<div class="datetime tblcell">[ {{ $moment(item['date']).format('YYYY/MM/DD') }} ]</div>
				</div>
			</div>
			<div class="text_area" v-html="item['text']"></div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		item: null
	},
	methods: {
		jumpBlog(url) {
			window.open(url);
		}
	}
}
</script>

<style lang="less">
.newsItem {
	width: 280px;
	height: 220px;
	cursor: pointer;
	
	.eyecatchImage {
		width: 100%;
		height: 160px;
		background-size: cover;
		background-position: center;
		border: 1px solid rgba(0,0,0,0.2);
	}
	
	.info_area {
		position: relative;
		top: -40px;
		left: 15px;
		width: 230px;
		min-height: 106px;
		background-color: white;
		padding: 10px;
		box-shadow: 0px 2px 4px 1px rgba(0, 0, 0, 0.2);
		
		.datetime {
			font-size: 0.8rem;
			font-weight: bold;
		}
		
		.title {
			width: 210px;
			font-weight: bold;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
		
		.text_area {
			font-size: 0.8rem;
			
			p {
				margin: 0;
				padding: 0;
			}
		}
	}
}
</style>
